import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isKnowledgeSourceConfig = objectOf({
  definition_id: string,
  excluded_fields: arrayOf(string),
});

export const isConversationalWorkflowStep = objectOf({
  instruction: string,
  knowledge_source_configs: arrayOf(isKnowledgeSourceConfig),
});

export const isConversationalWorkflowResultObject = objectOf({
  id: string,
  name: string,
  purpose: string,
  steps: arrayOf(isConversationalWorkflowStep),
  created_by_email: string,
  created_at: string,
  updated_at: string,
});

export const isConversationalWorkflowResult = objectOf({
  result: isConversationalWorkflowResultObject,
});
